import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stars: false,
  sort: false,
  rating: false,
  board: false,
  stops: false,
  facilities: false,
  duration: false,
  nights: false,
  rates: false,
  mobile: false,
  refundability: false,
  luggage: false, // !localStorage.getItem('luggageFilterInteracted'),
  luggageTouched: false,
};

export const secondaryFilterModalsSlice = createSlice({
  name: 'secondaryFilter',
  initialState,
  reducers: {
    updateSecondaryFilterModal: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateSecondaryFilterModal } = secondaryFilterModalsSlice.actions;
export default secondaryFilterModalsSlice.reducer;
